import { useState, useEffect } from 'react';

// 响应式断点
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const useResponsive = () => {
  // 更安全的初始化
  const getInitialScreenSize = () => {
    if (typeof window === 'undefined') {
      return { width: 1024, height: 768 };
    }
    try {
      return {
        width: window.innerWidth || 1024,
        height: window.innerHeight || 768,
      };
    } catch (error) {
      console.warn('Error getting initial screen size:', error);
      return { width: 1024, height: 768 };
    }
  };

  const [screenSize, setScreenSize] = useState(getInitialScreenSize);
  const [currentBreakpoint, setCurrentBreakpoint] = useState(() => {
    const initialSize = getInitialScreenSize();
    if (initialSize.width < breakpoints.sm) return 'xs';
    if (initialSize.width < breakpoints.md) return 'sm';
    if (initialSize.width < breakpoints.lg) return 'md';
    if (initialSize.width < breakpoints.xl) return 'lg';
    return 'xl';
  });

  useEffect(() => {
    // 如果不在浏览器环境，直接返回
    if (typeof window === 'undefined') {
      return;
    }

    const handleResize = () => {
      try {
        const width = window.innerWidth || 1024;
        const height = window.innerHeight || 768;
        
        setScreenSize({ width, height });
        
        // 确定当前断点
        if (width < breakpoints.sm) {
          setCurrentBreakpoint('xs');
        } else if (width < breakpoints.md) {
          setCurrentBreakpoint('sm');
        } else if (width < breakpoints.lg) {
          setCurrentBreakpoint('md');
        } else if (width < breakpoints.xl) {
          setCurrentBreakpoint('lg');
        } else {
          setCurrentBreakpoint('xl');
        }
      } catch (error) {
        console.warn('Error in handleResize:', error);
      }
    };

    // 初始化
    handleResize();

    // 监听窗口大小变化
    try {
      window.addEventListener('resize', handleResize);
      
      return () => {
        try {
          window.removeEventListener('resize', handleResize);
        } catch (error) {
          console.warn('Error removing resize listener:', error);
        }
      };
    } catch (error) {
      console.warn('Error adding resize listener:', error);
      return;
    }
  }, []);

  const isMobile = currentBreakpoint === 'xs' || currentBreakpoint === 'sm';
  const isTablet = currentBreakpoint === 'md';
  const isDesktop = currentBreakpoint === 'lg' || currentBreakpoint === 'xl';

  return {
    screenSize,
    currentBreakpoint,
    isMobile,
    isTablet,
    isDesktop,
    breakpoints: {
      isXs: currentBreakpoint === 'xs',
      isSm: currentBreakpoint === 'sm',
      isMd: currentBreakpoint === 'md',
      isLg: currentBreakpoint === 'lg',
      isXl: currentBreakpoint === 'xl',
    }
  };
}; 